const Success: React.FC<{}> = () => {
  return (
    <section className="p-item p-item-no-header2">
      <div className="l-inner">
        <div className="p-itemContents p-itemThanksContents">
          <h2 className="c-sectionTitle is-en">Thank you for registration.</h2>
          <p className="p-item__titlelowTxt">
            Your information has been successfully received.
          </p>
        </div>
      </div>
    </section>
  );
};

export default Success;
